// LEGAL REVIEW REQUIRED
// One definition of every business fact the legal pages, order page and footer
// repeat. Anything still in square brackets is unresolved: see LEGAL_TODO.md at the
// repo root. `npm run check:legal` fails while a placeholder remains in src.

export const COMPANY = 'Korsa Inc.';
export const CONTACT_EMAIL = 'support@korsa.tech';
export const MAILING_ADDRESS = '145 Tremont Street, Suite 201-1840, Boston, MA 02111';
export const CITY = 'Newton, Massachusetts';

export const SHIP_WINDOW = 'Q1 2027';
export const REFUND_WINDOW = '10 business days';
export const RETURN_WINDOW = '30 days';
export const WARRANTY_PERIOD = '1 year';
export const A11Y_RESPONSE = '5 business days';

export const LEGAL_UPDATED = 'November 2026';
export const A11Y_REVIEWED = 'November 2, 2026';

export const LEGAL_LINKS = [
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Refunds and Cancellation', href: '/refunds' },
  { label: 'Cookie Notice', href: '/cookies' },
  { label: 'Accessibility', href: '/accessibility' },
];
